/**
 * Single-segment paths that must not be served as CMS blog articles on Radar.
 * Keep aligned with explicit routes in App.js (and with aquivo-site [slug] RESERVED where shared).
 */
const RAW = [
  "admin",
  "api",
  "about-us",
  "radar",
  "skope",
  "blog",
  "_next",
  "login",
  "register",
  "reset-password",
  "shopify-connect",
  "dashboard",
  "shopify",
  "auth",
  "terms",
  "privacy",
  "gdpr",
  "tools",
  "guides",
  "meta-ads-spy-tool",
  "tiktok-ads-spy-tool",
  "meta-ads-library-alternative",
  "ad-script-generator",
  "google-ads-competitor-analysis",
  "solutions",
  "waitlist",
];

export const RESERVED_SLUGS = new Set(RAW.map((s) => s.toLowerCase()));
